const header = [
  { text: 'Name', value: 'name' },
  { text: 'Description', value: 'description' },
  { text: 'Retail Value', value: 'attributes.retail_value' },
  { text: 'Shipping Cost', value: 'attributes.shipping_cost' },
  { text: 'Currency', value: 'attributes.currency' },
  { text: 'Action', value: 'actions', sortable: false }
]

export default header
